import { render, staticRenderFns } from "./NavigationArvea.vue?vue&type=template&id=f8f79e8c"
import script from "./NavigationArvea.vue?vue&type=script&lang=js"
export * from "./NavigationArvea.vue?vue&type=script&lang=js"
import style0 from "./NavigationArvea.vue?vue&type=style&index=0&id=f8f79e8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports